import _Cancel from "@mui/icons-material/Cancel";
import _CheckCircle from "@mui/icons-material/CheckCircle";
import _RemoveCircle from "@mui/icons-material/RemoveCircle";
import { COLORS } from '@fupa/fupa-uikit';
import React from 'react';
import styled from 'styled-components';
const GreyRemoveCircle = styled(_RemoveCircle).withConfig({
  componentId: "sc-odf9fq-0"
})(["color:", ";"], COLORS.grey);
const GreenCheckCircle = styled(_CheckCircle).withConfig({
  componentId: "sc-odf9fq-1"
})(["color:", ";"], COLORS.lightGreen);
const RedCancel = styled(_Cancel).withConfig({
  componentId: "sc-odf9fq-2"
})(["color:", ";"], COLORS.lightRed);
export let Result = /*#__PURE__*/function (Result) {
  Result["Win"] = "win";
  Result["Loss"] = "loss";
  Result["Draw"] = "draw";
  return Result;
}({});
const mapResultToIcon = {
  [Result.Draw]: id => /*#__PURE__*/React.createElement(GreyRemoveCircle, {
    key: id,
    fontSize: "small"
  }),
  [Result.Win]: id => /*#__PURE__*/React.createElement(GreenCheckCircle, {
    key: id,
    fontSize: "small"
  }),
  [Result.Loss]: id => /*#__PURE__*/React.createElement(RedCancel, {
    key: id,
    fontSize: "small"
  })
};
const getFormStandingsLastResults = lastResults => lastResults === null || lastResults === void 0 ? void 0 : lastResults.map((lastResult, id) => {
  return mapResultToIcon[lastResult](id);
});
export default getFormStandingsLastResults;